export const SELECT_PRODUCTS_BASED_ON_ALL = "SELECT_PRODUCTS_BASED_ON_ALL";
export const SELECT_PRODUCTS_BASED_ON_SPECIFIC = "SELECT_PRODUCTS_BASED_ON_SPECIFIC";
export const SELECT_PRODUCTS_BASED_ON_TAGS = "SELECT_PRODUCTS_BASED_ON_TAGS";
export const SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_ATTRIBUTE = "SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_ATTRIBUTE";
export const SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_TAG = "SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_TAG";
export const SELECT_PRODUCTS_BASED_ON_HAVE_TAG = "SELECT_PRODUCTS_BASED_ON_HAVE_TAG";
export const SELECT_PRODUCTS_BASED_ON_HAVE_ATTRIBUTE = "SELECT_PRODUCTS_BASED_ON_HAVE_ATTRIBUTE";
export const SELECT_PRODUCTS_BASED_ON_MULTIPLE_CONDITIONS = "SELECT_PRODUCTS_BASED_ON_MULTIPLE_CONDITIONS";
